module.exports = __webpack_public_path__ + "static/media/articles.06984dba.png";